// extracted by mini-css-extract-plugin
export default {"vertical-bottom-name":"EbOSN8UZBHz4ViwOM_EC","type-default":"LIOo_DCzovzhuwgnmKWt","type-small":"PTEXdfvQ7jt_q07mfTPB","common_bganimation":"mI8PJZTYn8xeUAikURoH"};